function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useRef } from 'react';
import { useSearchkit, useSearchkitQueryValue } from '@searchkit/client';
import FormikWrapper from '../../Form/FormikWrapper';
import Button from '../../Button';
import TextField from '../../Form/TextField';
var SearchField = function SearchField(_ref) {
  var timeout = _ref.timeout,
    _ref$autoSearch = _ref.autoSearch,
    autoSearch = _ref$autoSearch === void 0 ? true : _ref$autoSearch,
    buttonText = _ref.buttonText,
    placeholder = _ref.placeholder;
  var _useSearchkitQueryVal = useSearchkitQueryValue(),
    _useSearchkitQueryVal2 = _slicedToArray(_useSearchkitQueryVal, 2),
    query = _useSearchkitQueryVal2[0],
    setQuery = _useSearchkitQueryVal2[1];
  var api = useSearchkit();
  var timeoutRef = useRef();
  var fieldLabel = false;
  var searchQuery = function searchQuery(query) {
    setQuery(query);
    api.setQuery(query);
    api.search();
  };
  var onSubmit = function onSubmit(values, form) {
    searchQuery(values.query);
  };
  var onChange = function onChange(e) {
    e.persist();
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(function () {
      searchQuery(e.target.value);
    }, timeout);
  };
  var handleEnter = function handleEnter(event) {
    if (event.key === 'Enter') {
      onSubmit();
    }
  };
  return /*#__PURE__*/React.createElement(FormikWrapper, {
    initialValues: {
      query: query
    },
    displayRequiredIndicator: "required",
    enableReinitialize: true,
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
    fieldName: "query",
    title: fieldLabel,
    placeholder: placeholder,
    onChange: autoSearch ? function () {
      return onChange;
    } : function () {
      return handleEnter;
    }
  }), !autoSearch && /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    primary: true
  }, buttonText)));
};
SearchField.defaultProps = {
  timeout: 1000,
  autoSearch: true,
  buttonText: '',
  placeholder: ''
};
export default SearchField;